import React, { useState } from 'react';
import { USERS } from '../data/dummyData';

const AuthPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email.');
      return;
    }
    const user = USERS.find(u => u.email.toLowerCase() === email.toLowerCase() && u.password === password);
    if (!user) {
      setError('Invalid email or password.');
      return;
    }
    onLogin({ email: user.email });
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f6fff0' }}>
      <form onSubmit={handleSubmit} style={{ background: '#fff', padding: 36, borderRadius: 16, boxShadow: '0 2px 16px #0001', minWidth: 340, maxWidth: 360 }}>
        <h2 style={{ marginBottom: 24, color: '#1db954', fontWeight: 700, fontSize: '1.5rem', textAlign: 'center' }}>Sign In</h2>
        <div style={{ marginBottom: 18 }}>
          <label htmlFor="email" style={{ display: 'block', fontWeight: 500, marginBottom: 6 }}>Email Address</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #cce5d6', fontSize: 16 }}
            autoFocus
            required
          />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label htmlFor="password" style={{ display: 'block', fontWeight: 500, marginBottom: 6 }}>Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #cce5d6', fontSize: 16 }}
            required
          />
        </div>
        {error && <div style={{ color: '#e53935', marginBottom: 12 }}>{error}</div>}
        <button type="submit" style={{ width: '100%', background: '#1db954', color: '#fff', fontWeight: 700, border: 'none', borderRadius: 8, padding: '12px 0', fontSize: 16, cursor: 'pointer', marginTop: 8 }}>
          Sign In
        </button>
      </form>
    </div>
  );
};

export default AuthPage; 